module.exports = __webpack_public_path__ + "img/no-finalize.9ba0b06b.svg";